<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
            v-model="error.show"
            @hidden="error.show = false"
        >
            <card shadow type="secondary" class="m--4">
                <div class="row py-4">
                    <div class="col-lg-12 text-center">
                        <span class="text-red">
                            <i class="fas fa-exclamation-triangle fa-5x"></i>
                        </span>
                        <h3 class="py-2">ไม่สามารถยกเลิกรายการที่เลือกได้</h3>
                    </div>
                    <div class="col-lg-12 text-right pt-2">
                        <b-button 
                            size="lg" 
                            variant="danger"
                        >
                            ลองใหม่อีกครั้ง
                        </b-button>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
export default {
    name: "ModalError" ,
    props: {
        error: Object,
    },
    data(){
        return{
         
        }
    },
    methods:{
    }
}
</script>
